// Single JS entry point for toast notifications (window.showToast), used by
// Turbo Stream responses and Stimulus controllers. Markup comes from the
// Toast view component: the layout renders one hidden <template> per kind
// (shared/_toast_templates) and this module clones it, so server-rendered
// flash toasts and JS-spawned toasts are pixel-identical. Dismiss/auto-dismiss
// behavior lives in toast_controller.js via the cloned data-controller.

const KIND_ALIASES = {
  notice: "success",
  success: "success",
  alert: "error",
  error: "error",
  warning: "warning",
  info: "info",
};

function container() {
  let el = document.getElementById("toast-container");
  if (!el) {
    el = document.createElement("div");
    el.id = "toast-container";
    el.className = "fixed top-4 right-4 z-50 space-y-2";
    document.body.appendChild(el);
  }
  return el;
}

function showToast(message, type = "info") {
  const kind = KIND_ALIASES[type] || "info";
  const template = document.querySelector(
    `template[data-toast-template="${kind}"]`,
  );
  if (!template) {
    // Layout without templates (shouldn't happen) — fail quietly but visibly
    console.warn("showToast: no toast template for", kind);
    return;
  }

  const toast = template.content.firstElementChild.cloneNode(true);
  toast.querySelector("[data-toast-message]").textContent = message;
  container().appendChild(toast);
}

window.showToast = showToast;

export { showToast };
